import React from "react";
import { Series } from "../../../components/Charts";
import {
  ChartSkeleton,
  ChartSkeletonBody,
  ChartSkeletonTitle,
  TimelineChartWrapper,
  TimelineSectionRow,
  RecentTransactionsCard,
} from "../styles";
import { TimelineChartContent } from "./TimelineChartContent";
import { RecentTransactions } from "./RecentTransactions";
import { BREAKPOINTS } from "../../../utils/constants";
import { Transaction } from "../../../services/transactions/types";

interface TimelineSectionProps {
  historyLoading: boolean;
  timelineSeries: Series[];
  timelineLabels: string[];
  windowWidth: number;
  recentTransactions: Transaction[];
  onCreateClick: () => void;
  onTransactionClick: (tx: Transaction) => void;
}

export const TimelineSection: React.FC<TimelineSectionProps> = React.memo(
  ({
    historyLoading,
    timelineSeries,
    timelineLabels,
    windowWidth,
    recentTransactions,
    onCreateClick,
    onTransactionClick,
  }) => {
    return (
      <TimelineSectionRow>
        <TimelineChartWrapper
          as="section"
          aria-label="Net Worth Evolution Chart"
          data-testid="timeline-chart"
        >
          {historyLoading ? (
            <ChartSkeleton>
              <ChartSkeletonTitle />
              <ChartSkeletonBody
                height={windowWidth < BREAKPOINTS.mobile ? 350 : 500}
              />
            </ChartSkeleton>
          ) : (
            <TimelineChartContent
              timelineSeries={timelineSeries}
              timelineLabels={timelineLabels}
              windowWidth={windowWidth}
            />
          )}
        </TimelineChartWrapper>

        <RecentTransactionsCard as="section" aria-label="Recent Transactions">
          <RecentTransactions
            transactions={recentTransactions}
            onCreateClick={onCreateClick}
            onTransactionClick={onTransactionClick}
          />
        </RecentTransactionsCard>
      </TimelineSectionRow>
    );
  },
);

TimelineSection.displayName = "TimelineSection";
